"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FastBackwardFill = {
    name: 'fast-backward',
    theme: 'fill',
    nameWithTheme: 'fast-backward-fill',
    tag: 'svg',
    attrs: { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 1024 1024' },
    children: [
        {
            tag: 'path',
            attrs: {
                d: 'M524.6 481.6l436.2-375.4c24.4-22.8 63.1-4.7 63.1 29.5v752.7c0 34.2-38.7 52.3-63.1 29.5L524.6 540.6c-8.4-7.9-12.6-18.7-12.7-29.5.1-10.9 4.3-21.7 12.7-29.5z'
            },
            children: []
        },
        {
            tag: 'path',
            attrs: {
                d: 'M36 96c19.9 0 36 16.1 36 36v298.5l376.9-324.4c24.4-22.8 63.1-4.7 63.1 29.5v752.7c0 34.2-38.7 52.3-63.1 29.5L72 591.9V892c0 19.9-16.1 36-36 36S0 911.9 0 892V132c0-19.9 16.1-36 36-36z'
            },
            children: []
        }
    ]
};
exports.default = FastBackwardFill;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@ant-design/icons/lib/fill/FastBackwardFill.js
// module id = 668
// module chunks = 0